(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingReviewBooking',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// $('.add-payment-link').click(function click(e) {
		// 	e.preventDefault();

		// 	Adzuki.StatusMessage('warning', 'The ability to submit a payment along with a new booking is currently unavailable. Please submit your booking as an OPTION and THEN submit a payment for it separately using CP Maxx. At the end of the OPTION booking process, there will be a button that says "Finish and Submit Payment". You can click that button to go DIRECTLY to the payment submission interface.', 'Currently Unavailable');
		// });
	};
}(jQuery, window.Adzuki || {}));
